<template>
    <ul
        class="list list-unstyled tw-m-0 tw-grid tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-5 2xl:tw-gap-10"
    >
        <li
            v-for="badge in badges"
            :key="badge._id"
            class="tw-relative tw-transform tw-duration-200 hover:tw-scale-105 hover:tw-border-gray-400 tw-text-center tw-select-none tw-cursor-pointer tw-rounded-md tw-border tw-border-solid tw-border-gray-200"
            :class="{
                'tw-cursor-wait': loading,
                'tw-scale-105 tw-border-gray-400 ': selectedBadge === badge._id,
            }"
            :title="badge.name"
            @click="onClick(badge._id)"
            @keyup.enter="onClick(badge._id)"
        >
            <div class="tw-p-5">
                <div class="tw-h-12 tw-bg-gray-50 tw-rounded tw-text-center tw-align-middle">
                    <img
                        v-if="badge.icon"
                        class="tw-max-w-full tw-max-h-12"
                        :alt="badge.name"
                        :src="badge.icon"
                    />
                    <i v-else class="fal fa-trophy tw-leading-10" />
                </div>
            </div>
            <div
                class="tw-text-xs tw-overflow-hidden tw-text-gray-500 tw-px-1 tw-pb-5 tw-pt-0 tw--mt-1"
            >
                <div class="truncate-3">{{ badge.name }}</div>
            </div>
            <div
                class="tw-absolute tw-rounded-full tw-leading-8 tw-text-center tw-bg-indigo-50 tw-text-indigo-400 tw--top-4 tw--right-4 tw-text-xs tw-w-8 tw-h-8"
            >
                {{ badge.amount }}
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        selectedBadge: {
            type: String,
            default: "",
        },
        badges: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(badgeId) {
            if (!badgeId || this.loading) return;

            if (window.scrollY <= 250) {
                // scroll into view on first usage
                this.$parent?.$parent?.$refs?.filter?.$el?.scrollIntoView({
                    block: "end",
                    behavior: "smooth",
                });
            }

            this.$emit("sortChange", "badge", badgeId);
        },
    },
};
</script>

<style scoped>
.truncate-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 3;
}
</style>
